import it from './config-it.js'
import de from './config-de.js'
import es from './config-es.js'
import fr from './config-fr.js'
import en from './config-en.js'

export default {
  it,
  de,
  es,
  fr,
  en,
}
